import React from 'react';
import LegalLayout, {
  LegalSection,
  LegalParagraph,
  LegalList,
  LegalNote
} from './LegalLayout';

const CancellationPolicy = () => (
  <LegalLayout
    title="Cancellation &amp; Payment Policy"
    effectiveDate="Effective from 1 June 2026"
    pageTestId="cancellation-policy-page"
  >
    <LegalParagraph>
      We want every family to feel comfortable and informed about how payments,
      rescheduling, and cancellations work at Read Right Academy. This policy
      applies to all paid programmes (One-to-One, Read Together, Teacher
      Training, and Parent Programmes).
    </LegalParagraph>

    <LegalSection heading="1. Free Trial Class">
      <LegalNote tone="info">
        The Free Trial Class has no charge and no cancellation fee. If you
        cannot attend, simply WhatsApp us to reschedule or cancel.
      </LegalNote>
    </LegalSection>

    <LegalSection heading="2. Fees and Payment Schedule">
      <LegalList
        items={[
          'Fees for each programme are confirmed in writing (WhatsApp or email) at the time of enrolment.',
          'Payment is typically made monthly in advance, unless a different schedule is agreed.',
          'Payment confirms your seat for the upcoming month or term.'
        ]}
      />
    </LegalSection>

    <LegalSection heading="3. Rescheduling Individual Classes">
      <LegalList
        items={[
          'One-to-One classes can be rescheduled with at least 24 hours\' notice, subject to teacher availability.',
          'Read Together (group) classes follow a fixed weekly schedule. If a child misses a class, recordings or catch-up notes may be provided where possible.'
        ]}
      />
    </LegalSection>

    <LegalSection heading="4. Cancellation by the Parent / Participant">
      <LegalList
        items={[
          'You may cancel ongoing enrolment at any time by giving us at least 14 days\' written notice (WhatsApp or email).',
          'Fees already paid for the current month are non-refundable, but you retain access to all scheduled classes for that period.',
          'No long-term contracts — you only pay for the period you choose to enrol in.'
        ]}
      />
    </LegalSection>

    <LegalSection heading="5. Cancellation by Read Right Academy">
      <LegalParagraph>
        In rare cases (illness, technical issues, or other unforeseen
        circumstances), we may need to cancel a scheduled class. When this
        happens:
      </LegalParagraph>
      <LegalList
        items={[
          'We will notify you as early as possible',
          'We will offer a replacement class at no extra cost, or',
          'A pro-rata credit will be applied to your next invoice.'
        ]}
      />
    </LegalSection>

    <LegalSection heading="6. Refunds">
      <LegalParagraph>
        Refunds are offered only in the following situations:
      </LegalParagraph>
      <LegalList
        items={[
          'We cancel a programme entirely before it begins.',
          'A duplicate or incorrect payment is received from you.',
          'Any other circumstance we agree to in writing.'
        ]}
      />
    </LegalSection>

    <LegalSection heading="7. Late or Missed Payment">
      <LegalParagraph>
        If a payment is not received within 7 days of the agreed date, your
        child&apos;s seat may be paused until payment is settled. We will
        always communicate with you before any pause.
      </LegalParagraph>
    </LegalSection>
  </LegalLayout>
);

export default CancellationPolicy;
